module.exports = __webpack_public_path__ + "static/media/made-in-italy-icon.9591bf46.png";